import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";

export interface RedirectToActiveOrNewMemItSessionProps {
  inSidePanel?: boolean;
}

export const RedirectToActiveOrNewMemItSession = observer<RedirectToActiveOrNewMemItSessionProps>(
  function RedirectToActiveOrNewMemItSession({ inSidePanel = false }) {
    const { store, pageStore } = useAppStore();

    useEffectOnMount(() => {
      const autoRouteToSession = async () => {
        // Try to resume an active session
        const resumedSessionId = await pageStore.memItPage.resumeActiveSession();
        const sessionId = resumedSessionId || (await pageStore.memItPage.getPlaceholderSessionId());
        if (inSidePanel) {
          store.sidePanel.goToMemIt(sessionId);
        } else {
          store.navigation.goToMemIt({ sessionId });
        }
      };

      autoRouteToSession();
    });

    return null;
  }
);
